import AddressConfirmationScreen from 'features/personalInfo/confirmYourAddress/screens/AddressConfirmationScreen/AddressConfirmationScreen';
import FeatureLevelErrorScreen from 'features/personalInfo/confirmYourAddress/screens/AddressConfirmationWrapperScreen/FeatureLevelErrorScreen';
import React from 'react';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';

const AddressConfirmationWrapperScreen = () => {
  const { isFeatureEnabled } = useStatsig();

  if (isFeatureEnabled(FeatureFlagKey.ADDRESS_CONFIRMATION_FEATURE)) {
    return <AddressConfirmationScreen />;
  }
  return <FeatureLevelErrorScreen />;
};

export default AddressConfirmationWrapperScreen;
